<template>
  <div id="home">
    <my-header></my-header>
    <div class="pd20">
      <div class="row">
        <div class="col-md-12">
          <h3 >{{'Purchases History'|translate}}</h3>
          <div class="mt20">
            <div class="row">
              <div class="col-md-12 col-xs-12">
                  <a class="btn btn-primary"  v-on:click="showModal(null)">{{'Add'|translate}}</a>    
              </div>
              <div class="col-md-12 col-xs-12 mt20">
              <form class="form-inline">
                <div class="form-group">
                    <select class="form-control" v-model="search_obj.view" @change="changeView">
                      <option value="">{{"All types"|translate}}</option>
                      <option value="buy">{{"Buy"|translate}}</option>
                      <option value="sell">{{"Sell"|translate}}</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <select
                      class="form-control"
                      v-model="search_obj.behavior_index"
                      @change="list"
                    >
                      <option value>{{"All behaviors"|translate}}</option>
                      <option v-for="(buyer,index) in all_behaviors" :key="index" v-bind:value="index">
                        {{ buyer.name }}
                        <span>({{buyer.type|translate}})</span>
                      </option>
                    </select>
                  </div>
   
                  <div class="form-group">
                    <select
                      class="form-control"
                      v-model="search_obj.status"
                      @change="list"
                    >
                      <option value>{{"All status"|translate}}</option>
                      <option v-for="(item) in all_status" :key="item.id" v-bind:value="item.id">
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
              </form>
              </div>
            </div>
            
            
          </div>

          <loading v-if="list_items == null" class="mt20" :text="'Please wait'|translate"></loading>

          <p
            class="mt20 alert clear alert-info"
            v-if="list_items && list_items.length == 0"
          >{{'There is no data'|translate}}</p>
          <div class="table-responsive">
            <table class="table mt10" v-if="list_items && list_items.length > 0">
              <thead>
                <tr>
                  <!-- <th width="5%">{{'ID'|translate}}</th> -->
                  <th width="20%">{{'Buyer'|translate}}</th>
                  <th width="15%">{{'Seller'|translate}}</th>
                  <th width="10%">{{'Items'|translate}}</th>
                  <th width="10%">{{'Total Price'|translate}}</th>

                  <th width="12%">{{'Status'|translate}}</th>
                  <th width="30%">{{'Action'|translate}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item) in list_items" :key="item.id">
                  <!-- <td>
                    <router-link :to="{ name: 'PurchaseDetail', params: { id:item.id }}">{{item.id}}</router-link>
                  </td> -->
                  <td>
                    <p v-if="item.buyer_type =='retailer'">
                      <router-link :to="{ name: 'Profile', params: { profileId:item.buyer_id }}">{{ item.buyer_name }} <span>({{item.buyer_type|translate}})</span></router-link>
                    </p>
                    <p v-if="item.buyer_type =='group'">
                      <router-link :to="{ name: 'GroupProfile', params: { id:item.buyer_id }}">{{ item.buyer_name }} <span>({{item.buyer_type|translate}})</span></router-link>
                    </p>
                  </td>
                  <td>
                    <p v-if="item.seller_type =='farmer'">
                      <router-link :to="{ name: 'Profile', params: { profileId:item.seller_id }}">{{ item.seller_name }} <span>({{item.seller_type|translate}})</span></router-link>
                    </p>
                    <p v-if="item.seller_type =='group'">
                      <router-link :to="{ name: 'GroupProfile', params: { id:item.seller_id }}">{{ item.seller_name }} <span>({{item.seller_type|translate}})</span></router-link>
                    </p>
                  </td>
                  <td>{{ item.count_items }}</td>
                  <td>{{ toCommas(item.total_price) }}</td>

                  <td>{{ showStatus(item.status) }}</td>
                  <td>

                    <!-- <a class="btn btn-info" v-on:click="showModal(item)">
                      <span v-if="item.status == 0">{{'Update'|translate}}</span>
                      <span v-if="item.status != 0">{{'View'|translate}}</span>
                    </a> -->
                    <router-link class="btn btn-info" :to="{ name: 'PurchaseDetail', params: { id:item.id }}">{{'Detail'|translate}}</router-link>
                    <a
                      class="btn btn-danger"
                      v-if="item.status == 0"
                      v-on:click="removeItem(item)"
                      :disabled="removing"
                    >{{'Delete'|translate}}</a>
                    <a
                      v-if="item.status == 0"
                      class="btn btn-primary"
                      v-on:click="updateStatus(item, 'send')"
                      :disabled="updating"
                    > <i v-if="updating" class="fas fa-spinner fa-spin"></i> {{'Send'|translate}}</a>

                    <a
                      v-if="item.status == 1 && item.seller_user_id === user['id'] "
                      class="btn btn-primary"
                      v-on:click="updateStatus(item,'confirm')"
                    :disabled="updating"
                    > <i v-if="updating" class="fas fa-spinner fa-spin"></i> {{'Confirm'|translate}}</a>
                    <a
                      v-if="item.status == 2 && item.seller_user_id === user['id'] "
                      class="btn btn-primary"
                      v-on:click="updateStatus(item,'delivery')"
                    :disabled="updating">
                    <i v-if="updating" class="fas fa-spinner fa-spin"></i> {{'Set as delivery'|translate}}</a>
                    <a
                      v-if="item.status == 3 && item.buyer_user_id === user['id'] "
                      class="btn btn-primary"
                      v-on:click="updateStatus(item,'done')"
                    :disabled="updating"
                    > <i v-if="updating" class="fas fa-spinner fa-spin"></i> 
                    {{'Set as done'|translate}}</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <paginate
            v-if="total_page > 1"
            :page-count="total_page"
            :click-handler="clickPage"
            :prev-text="'Prev'|translate"
            :next-text="'Next'|translate"
            v-model="page"
            :container-class="'pagination'"
          ></paginate>
        </div>
      </div>
    </div>
    <form-purchase-modal
      v-if="show_form"
      ref="formSubUser"
      :from_buyers="buyer_behaviors"
      :pass_data="pass_data"
      @modalData="modalData"
    ></form-purchase-modal>
    <p class="pd20"><strong>{{'Total'|translate}}: </strong> {{this.total}}  </p>
    <p class="pd20">
      <strong>Ghi chú tình trạng</strong>:
      <br />1. Chưa gửi : đơn hàng tạo nháp và chưa chốt mặt hàng bởi người mua
      <br />2. Đã Gửi : Đơn hàng được chốt mặt hàng bởi người mua và gửi cho người bán .
      <br />3. Đã Xác nhận : Đơn hàng được xác nhận bởi người bán
      <br />4. Đã chuyển : Người bán đã chuyển hàng cho người mua
      <br />5. Hoàn thành: Người mua đã nhận được hàng và kết thúc
      <br />
    </p>
  </div>
</template>
<script>
// http://farmbook.com/API/listProduct
import Utils from "@/helpers/utils";
import MyHeader from "@/components/Layout/Header";
import FormPurchaseModal from "@/components/Purchase/FormPurchaseModal";
import Paginate from "vuejs-paginate";
// import ProfileSidebar from "@/components/Profile/ProfileSidebar";
import Loading from "@/components/elements/Loading";
export default {
  name: "Home",
  components: {
    MyHeader,
    FormPurchaseModal,
    Paginate,
    Loading
    // ProfileSidebar
  },

  data() {
    return {
      show_form: false,
      pass_data: null,
      list_items: null,
      all_behaviors: [],
      from_sellers: [],
      all_status: [
        {id:0, name:'Chưa gửi'},
        {id:1, name:'Đã gửi'},
        {id:2, name:'Đã Xác nhận'},
        {id:3, name:'Đã chuyển hàng'},
        {id:4, name:'Hoàn thành'}
      ],
      removing: false,
      updating: false,
      page: 1,
      user: null,
      offset: 0,
      search_obj: {
        view: "",
        status: '',
        keyword: "",
        behavior_index: ""
      },
    total :0,
      limit: Utils.getLimit(),
      total_page: 1
    };
  },

  methods: {
    changeView() {
      if (this.search_obj.view == "sell") {
        console.log("1");
        this.$router.push({
          name: "ListTypePurchase",
          params: { type: "sell" }
        });
      } else {
      
        this.$router.push({ name: "ListPurchase" });
      }
      
      // if(this.search_obj.view == "buyer"){
      //   this.search_obj.seller_index = "";
      //   console.log('1')
      // }else{
      //   this.search_obj.behavior_index = "";
      //   console.log('2')
      // }
      this.list();
    },
    showStatus(status) {
     return Utils.orderStatus(status)
    },
    toCommas(value) {
      return Utils.toCommas(value);
    },
    modalData(data) {
      this.list();
    },
    showModal(data) {
      this.show_form = true;

      this.pass_data = data != null ? JSON.parse(JSON.stringify(data)) : data;

      setTimeout(() => {
        this.$refs.formSubUser.open();
      });
    },
    search() {
      this.list();
    },
    list() {
      let data = JSON.parse(JSON.stringify(this.search_obj));
      if (this.search_obj.behavior_index !== "") {
        data.behavior_id = this.all_behaviors[this.search_obj.behavior_index].id;
        
        data.behavior_type = this.all_behaviors[this.search_obj.behavior_index].type;
        
      }
  
      data.offset = this.offset;
      data.limit = this.limit;
      this.list_items = null;

      Utils.request(this, true, "purchase")
        .get(`/manageOrder/?${Utils.arrayToRequestParam(data)}`)
        .then(response => {
          let data = response.data;
          console.log("data", data);

          if (data.status === "ok") {
            this.list_items = data.data.list;
            this.total = data.data.total;
            this.total_page = Utils.getTotalPages(this.total, this.limit);

            // update local storage
          }
        })
        .catch(error => {
          this.updating = false;
          Utils.showErrorMessage(this, error.response);
        });
    },
    removeItem(item) {
      this.$alertify.confirmWithTitle(
        this.$t("Confirm"),
        this.$t("Are you sure to remove this item ?"),
        () => {
          this.removing = true;
          Utils.request(this, true, "purchase")
            .delete(`/manageOrder/${item.id}`)
            .then(response => {
              this.removing = false;
              let data = response.data;
              if (data.status === "ok") {
                this.offset = 0;
                this.list();
              }
            });
        }
      );
    },
    clickPage(pageNum) {
      this.offset = Utils.getNextOffset(pageNum, this.limit);
      this.list();
    },
    getSourceBuyer() {
      Utils.request(this, true, "purchase")
        .get(`/get_source_behaviors/`)
        .then(response => {
          // this.all_behaviors = response.data.data;
          this.buyer_behaviors = response.data.data.buyers;
          this.all_behaviors = response.data.data.all;
          
          
        });
    },
    updateStatus(purchase, path) {
      var message = "";
      
      switch( path ){
        case 'send': 
          message = this.$t("Are you sure to send this purchase and send to seller ?");
          break;
        case 'confirm': 
          message = this.$t("Are you sure to confirm this purchase to buyer ?");
          break;
        case 'delivery': 
          message = this.$t("Are you sure to set this purchase is delivery to buyer ?");
          break;
        case 'done': 
          message =  this.$t("Are you sure to set this purchase is done ?");
          break;
      }
      this.$alertify.confirmWithTitle(
        this.$t("Confirm"),
        message,
        () => {
          this.updating= true;
          Utils.request(this, true, "purchase")
            .put(`/${path}/${purchase.id}`)
            .then(response => {
              this.updating = false;
              let data = response.data;
              if (data.status === "ok") {
                this.offset = 0;
                this.list();
              } else {
                Utils.showError(this, data.data);
              }
            });
        }
      );
    },

  },
  mounted() {
    if (this.$route.params.type == "sell") {
      this.search_obj.view = "sell";
    }
    this.list();
    this.user = Utils.getUser(this);
    this.getSourceBuyer();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Purchase/Purchase.vue